var API_DOMAIN = "https://ecomdemo.zentexus.in/api";

export default API_DOMAIN;
